/* assets/int-sticky-atc.js
   Moved out of snippets/int-sticky-atc.liquid on 2026-09-10 to cut the PDP HTML payload.
   It rendered as a 19,285 byte inline <script> block, most of it the per-variant options
   and availability array. That data is now JSON in #int-satc-data.
   PLAIN <script src>, NOT defer, at the exact position the inline block held. The first
   thing it does on desktop is remove the server-rendered int-has-sticky-atc body class,
   which is a CLS fix, so it must not be delayed. */

(function() {
  'use strict';
  if (window.innerWidth >= 768) {
    /* INT 2026-05: clean up the server-rendered int-has-sticky-atc body class
       on desktop. The class is rendered inline on body for apparel/framedprint
       templates to reserve the 62px padding-bottom from first paint (eliminates
       the 0.0105 CLS micro-shift). The bar itself only initializes on mobile,
       so on desktop we drop the class to avoid phantom padding if the user
       later resizes to mobile (resize handler short-circuits when data-ready
       has not been set, so it would not clean up otherwise). */
    document.body.classList.remove('int-has-sticky-atc');
    return;
  }

  var bar, btn, btnLabel, priceEl;
  var hasUserPickedSize = false;
  var initialSizeValue = null;

  /* INT 2026-06: scroll-reveal so the bar no longer covers the swatches on
     first paint. Same threshold as the page sticky CTAs.
     INT 2026-10-26 (sticky-atc-from-start, Nils agreed 26 Oct): the bar now follows the REAL
     Add to Cart button instead of the title. It shows whenever that button is off screen (below
     the first screen on load, or scrolled past) and steps aside while the button itself is in
     view, so the shopper never sees two Add to Cart buttons at once. The title rule below stays
     only as a fallback for a page with no real button. See HANDOVER-sticky-atc-from-start.md. */
  var stickyVisible = false;
  var stickyThreshold = 0;
  var stickyRaf = false;
  var stickyTitleEl = null;

  /* Full variants list — used to look up availability for the exact
     currently-selected option combination. Authoritative source; avoids
     transient false states in Pipeline V7.5's variant:change events. */
  /* 2026-09-10 PDP PAYLOAD: allVariants, productOptions, currentVariant and moneyFormat were
     built by Liquid right here. They now arrive as JSON in #int-satc-data, written by the
     snippet immediately above the <script src>. Shapes are identical. */
  var _D = {};
  try { _D = JSON.parse(document.getElementById('int-satc-data').textContent); } catch (e) { _D = {}; }
  var allVariants = _D.allVariants || [];
  var productOptions = _D.productOptions || [];
  var currentVariant = _D.currentVariant || {};
  var moneyFormat = _D.moneyFormat || '';

  /* INT 2026-10-11 (Nils 11:54 CEST): "it must show 60x80 by default, the same as the size
     selector, and then follow whatever is selected". The framed print PDP opens on 60x80
     SERVER SIDE (hero_variant, APPLIED-fp-default-variant-server-rendered-2026-09-20.md), but
     this bar is rendered from layout/theme.liquid, which cannot see that variant, so the
     snippet prints product.selected_or_first_available_variant (the cheapest size). The theme's
     own first theme:variant:change carries the right variant but fires BEFORE this file runs.
     So on init the bar reads the variant the product form actually holds ([name="id"]) and
     looks it up in the page's own product JSON (Pipeline's [data-product-json], ids, prices in
     the shopper's currency, availability). Nothing extra is printed into the page. */
  var pjVariants = null;
  function productJsonVariants() {
    if (pjVariants) return pjVariants;
    pjVariants = [];
    var nodes = document.querySelectorAll('script[data-product-json]');
    for (var i = 0; i < nodes.length && !pjVariants.length; i++) {
      try {
        var d = JSON.parse(nodes[i].textContent);
        var p = (d && d.product) ? d.product : d;
        if (p && p.variants && p.variants.length) pjVariants = p.variants;
      } catch (e) {}
    }
    return pjVariants;
  }
  function variantById(id) {
    id = parseInt(id, 10);
    if (!id) return null;
    var vs = productJsonVariants();
    for (var i = 0; i < vs.length; i++) { if (vs[i].id === id) return vs[i]; }
    return null;
  }
  function formVariant() {
    var el = document.querySelector('[data-form-holder] [name="id"]') ||
             document.querySelector('form[action*="/cart/add"] [name="id"]');
    return el ? variantById(el.value) : null;
  }
  /* A popout size control (framed prints: the size names are too long for radios) ALWAYS holds
     a value, it has no "nothing picked" state, so the bar never needs to ask for a size there.
     Apparel sizes are radios and keep the Select size step. */
  function sizeIsPopout() {
    var fs = findSizeFieldset();
    return !!(fs && !fs.querySelector('input[type="radio"]') && fs.querySelector('[data-popout]'));
  }
  function syncFromForm() {
    var v = formVariant();
    if (!v) return;
    currentVariant.price = v.price;
    currentVariant.available = !!v.available;
    if (priceEl && typeof v.price === 'number') priceEl.textContent = formatMoney(v.price, moneyFormat);
  }

  /* Money formatter — mirrors the Klarna installment script's version */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = parseInt(cents.replace('.', ''), 10);
    /* FIXED 2026-09-10, Nils. In the Liquid original this line read
         if (!format) format = '{{ amount }}';
       and the author meant the LITERAL Shopify money placeholder, which the switch below
       handles as case 'amount'. But Liquid saw an output tag for an undefined variable and
       substituted an empty string, so every page ever served ran `format = ''`. With an
       empty format the regex finds no match and the function returns String(cents), so the
       sticky bar would have printed `8900` instead of `EUR 89,00`. Unreachable in practice,
       moneyFormat is always set from shop.money_format, but it was wrong.
       Safe here because a .js asset is never parsed by Liquid.
       REVERT / RE-INLINE WARNING: if this file is ever pasted back into a .liquid file, the
       placeholder below MUST be wrapped in a raw tag or Liquid will eat it again. */
    if (!format) format = '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return String(cents);
    function sep(str, thou, dec) {
      thou = thou || ',';
      dec  = dec  || '.';
      var parts = str.split('.');
      var intPart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      var decPart = parts.length > 1 ? dec + parts[1] : '';
      return intPart + decPart;
    }
    var value;
    switch (match[1]) {
      case 'amount':                                  value = sep((cents / 100).toFixed(2), ',', '.'); break;
      case 'amount_no_decimals':                      value = sep(Math.round(cents / 100).toString(), ','); break;
      case 'amount_with_comma_separator':             value = sep((cents / 100).toFixed(2), '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = sep(Math.round(cents / 100).toString(), '.'); break;
      case 'amount_no_decimals_with_space_separator': value = sep(Math.round(cents / 100).toString(), ' '); break;
      case 'amount_with_apostrophe_separator':        value = sep((cents / 100).toFixed(2), "'", '.'); break;
      case 'amount_with_space_separator':             value = sep((cents / 100).toFixed(2), ' ', ','); break;
      default:                                        value = sep((cents / 100).toFixed(2), ',', '.');
    }
    return format.replace(placeholder, value);
  }

  function findSizeFieldset() {
    return document.querySelector('[data-select-label="Size"], [data-select-label="Frame Size"]');
  }

  function computeState() {
    /* No size fieldset at all (one-option product) → rely on variant availability */
    if (!findSizeFieldset()) {
      return currentVariant.available ? 'add-to-cart' : 'sold-out';
    }
    /* Size exists but user hasn't picked → always "Select size" regardless of stock.
       Stock for a specific size only matters once the user tells us which size. */
    if (!hasUserPickedSize) return 'select-size';
    /* Size picked → now the exact variant availability governs the state */
    return currentVariant.available ? 'add-to-cart' : 'sold-out';
  }

  function render() {
    if (!btn || !btnLabel) return;
    var state = computeState();
    btn.setAttribute('data-state', state);
    switch (state) {
      case 'select-size': btnLabel.textContent = _D.selectSize; break;
      case 'sold-out':    btnLabel.textContent = _D.soldOut;    break;
      default:            btnLabel.textContent = _D.addToCart;
    }
  }

  function onClick(e) {
    e.preventDefault();
    var state = btn.getAttribute('data-state');
    if (state === 'sold-out') return;

    if (state === 'select-size') {
      var fs = findSizeFieldset();
      if (!fs) return;
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fs.classList.remove('int-sticky-highlight');
      void fs.offsetWidth; /* restart animation */
      fs.classList.add('int-sticky-highlight');
      setTimeout(function() {
        var firstInput = fs.querySelector('input[type="radio"]');
        if (firstInput) { try { firstInput.focus({ preventScroll: true }); } catch(_) {} }
      }, 400);
      return;
    }

    /* The mobile sticky button sits outside the product form. Its old synthetic
       click was ignored on framed prints; requestSubmit navigated to /cart.
       Submit the same form data through Shopify Ajax and refresh the drawer. */
    var realBtn = document.querySelector('[data-form-holder] button[name="add"]:not([disabled])');
    if (!realBtn) return;
    var form = realBtn.form || realBtn.closest('form');
    if (!form || btn.disabled || !form.reportValidity()) return;
    var data = new FormData(form);
    if (!data.get('id')) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    root = root.replace(/\/?$/, '/');
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (typeof window.__intOpenCartDrawer === 'function') window.__intOpenCartDrawer({ pending: true });
    fetch(root + 'cart/add.js', {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(error) {
          throw new Error(error.description || error.message || 'Unable to add this item');
        });
        return fetch(root + 'cart.js', { credentials: 'same-origin' });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function(error) {
        if (typeof window.__intSetCartPending === 'function') window.__intSetCartPending(false);
        var message = document.querySelector('#drawer-cart [data-form-errors]');
        if (message) {
          message.textContent = error.message;
          message.style.display = 'block';
        }
      })
      .finally(function() {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  function onSizeChange(e) {
    var t = e.target;
    if (!t || t.type !== 'radio') return;
    var fs = t.closest('[data-select-label]');
    if (!fs) return;
    var label = (fs.getAttribute('data-select-label') || '').toLowerCase();
    if (label === 'size' || label === 'frame size') {
      hasUserPickedSize = true;
      render();
    }
  }

  function getCurrentSizeValue() {
    var fs = findSizeFieldset();
    if (!fs) return null;
    var checked = fs.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  /* Read the current state of every option selector (radio/swatch) on the
     page and return an object mapping option name → selected value. This is
     the single source of truth for what the user has picked. */
  function getSelectedOptions() {
    var picks = {};
    document.querySelectorAll('[data-select-label]').forEach(function(wrapper) {
      var name = wrapper.getAttribute('data-select-label');
      if (!name) return;
      var checked = wrapper.querySelector('input[type="radio"]:checked');
      if (checked) picks[name] = checked.value;
    });
    return picks;
  }

  /* Look up the variant matching the current option picks against the
     product's variant list. Returns null if no combination matches.
     This is authoritative — avoids Pipeline V7.5's transient false
     availability states during color swaps. */
  function findMatchingVariant() {
    if (!allVariants || !allVariants.length || !productOptions || !productOptions.length) return null;
    var picks = getSelectedOptions();
    /* Require every product option to have a pick, otherwise we can't
       uniquely identify a variant. */
    for (var i = 0; i < productOptions.length; i++) {
      if (!picks[productOptions[i]]) return null;
    }
    for (var j = 0; j < allVariants.length; j++) {
      var av = allVariants[j];
      if (!av.options) continue;
      var match = true;
      for (var k = 0; k < productOptions.length; k++) {
        var expected = picks[productOptions[k]];
        var actual = av.options[k];
        if (String(expected) !== String(actual)) { match = false; break; }
      }
      if (match) return av;
    }
    return null;
  }

  function onVariantChange(e) {
    if (!e.detail || !e.detail.variant) return;
    var v = e.detail.variant;

    /* Price: trust the event (always correct) */
    currentVariant.price = v.price;
    if (priceEl && typeof v.price === 'number') {
      priceEl.textContent = formatMoney(v.price, moneyFormat);
    }

    /* Availability: re-derive from our own lookup rather than trusting
       e.detail.variant.available. During color swaps Pipeline V7.5 can
       emit a variant:change event with stale/partial state. */
    var byId = variantById(v.id);
    var match = byId ? null : findMatchingVariant();
    if (byId) {
      currentVariant.available = !!byId.available;
    } else if (match) {
      currentVariant.available = !!match.available;
    } else {
      /* No exact match — either options haven't all been picked, or the
         combination doesn't exist. Treat as available so we show
         "Select size" rather than a false "Sold out". */
      currentVariant.available = true;
    }

    /* Pipeline V7.5 preventDefaults the radio click so native `change` never
       fires. Detect size selection by comparing the currently-checked size
       value against the page-load baseline. Any divergence = user picked. */
    var newSize = getCurrentSizeValue();
    if (newSize && initialSizeValue !== null && newSize !== initialSizeValue) {
      hasUserPickedSize = true;
    }
    render();
  }

  /* INT 2026-08-27: viewport height is CACHED, not read every frame.
     On mobile the browser's own URL bar collapsing and expanding changes
     window.innerHeight by 70-110px in the middle of a scroll while scrollY
     does not move at all. Reading it live moved both thresholds under the
     bar's feet. Refresh it only on a real viewport change (width changed,
     or a height jump too big to be browser chrome). */
  var stickyVh = 0;
  var stickyVw = 0;

  function computeStickyThreshold() {
    stickyTitleEl = document.querySelector('h1.product__title');
    var w = window.innerWidth;
    var h = window.innerHeight;
    if (!stickyVh || w !== stickyVw || Math.abs(h - stickyVh) > 150) {
      stickyVh = h;
      stickyVw = w;
    }
    /* Fallback only, used if the title element is ever missing. */
    stickyThreshold = Math.max(stickyVh * 0.9, 600);
  }

  /* The real Add to Cart: the first visible submit button inside the product form. */
  function realAtc() {
    var list = document.querySelectorAll('[data-form-holder] button[name="add"]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getClientRects().length && list[i].offsetHeight > 0) return list[i];
    }
    return null;
  }
  var CONTROL_SEL = '.int-gswatch, [data-select-label] .radio__button, [data-select-label] radio-swatch, ' +
                    '.int-fp-ctl__select, .int-mob-size, .int-size-select, [data-select-label] select';
  /* Nils 26 Oct 14:34, option B: the bar never covers a colour, size or frame control.
     Checked only while the real button is still below the bar. The bar keeps away from the
     colour, size and frame controls: it steps aside when one of them would be mostly hidden under
     it (at least half on screen, less than half left above the bar), and it stays away once one of
     them has fully come into view above it, because the shopper is then in the buying area and
     the real button is only a little further down. That keeps it to one hide and one show, no
     blinking. A control that only peeks in at the bottom edge is below the first screen anyway. */
  function controlsInTheWay(line, vh, headerH) {
    var els = document.querySelectorAll(CONTROL_SEL);
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (!(r.height > 0 && r.width > 0) || r.bottom <= headerH || r.top >= vh) continue;
      if (r.bottom <= line) return true;
      var onScreen = (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
      var aboveBar = Math.max(0, Math.min(r.bottom, line) - Math.max(r.top, 0)) / r.height;
      if (onScreen >= 0.5 && aboveBar < 0.5) return true;
    }
    return false;
  }

  function updateStickyVisible() {
    stickyRaf = false;
    if (!bar || bar.getAttribute('data-ready') !== '1') return;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var shouldShow = stickyVisible;
    var atc = realAtc();
    if (atc) {
      /* Live viewport height on purpose: the bar's own state never changes it, so there is no
         loop, and a collapsing browser bar that brings the real button into view should hide it. */
      var vh = window.innerHeight;
      var line = vh - (bar.offsetHeight || 62);
      var r = atc.getBoundingClientRect();
      var headerH = 64;
      var inView = stickyVisible
        ? (r.top < line && r.bottom > headerH)            /* hide once it has fully come out from under the bar */
        : (r.top < line + 8 && r.bottom > headerH - 8);  /* 8px of slack so it cannot flicker at the edge */
      shouldShow = !inView;
      if (shouldShow && r.top >= line - 8 && controlsInTheWay(line, vh, headerH)) shouldShow = false;
    } else if (stickyTitleEl) {
      /* Reveal once the title has risen to ~80% down the viewport, same intent
         as before, but expressed as a SCROLL POSITION so the show point and the
         hide point are always a fixed distance apart.

         INT 2026-08-27: the old rule compared the live title position against
         0.8*vh to show and against vh to hide. On any layout where the title
         already sits above 0.8*vh while the page is at rest, that band
         collapses to nothing and the only thing holding the bar down is
         scrollY < 4, so a rubber-band bounce, an inertia overshoot or a few
         px of scroll at the top slid the bar up and down repeatedly.
         Title position is still measured live, so gallery layout shifts and
         variant swaps are still handled. */
      var titleDocTop = stickyTitleEl.getBoundingClientRect().top + y;
      var showAt = Math.max(titleDocTop - stickyVh * 0.8, 120);
      var hideAt = Math.max(showAt - 140, 0);
      if (!stickyVisible && y >= showAt) shouldShow = true;
      else if (stickyVisible && y <= hideAt) shouldShow = false;
    } else {
      shouldShow = y >= stickyThreshold;
    }
    if (shouldShow === stickyVisible) return;
    stickyVisible = shouldShow;
    bar.setAttribute('data-visible', shouldShow ? '1' : '0');
  }

  function onStickyScroll() {
    if (stickyRaf) return;
    stickyRaf = true;
    requestAnimationFrame(function() { updateStickyVisible(); irisCheck(); });
  }

  /* INT 2026-10-26 (Nils yes 15:12 CET, sticky-atc-from-start, Iris step-aside): on phones the Iris
     button fades and slides out ONLY while its resting spot would sit on a buying control, and comes
     back as soon as that spot is clear. Iris's own files are untouched: this file decides, one body
     class (int-iris-aside) does it, the rule is at the end of assets/int-sticky-atc.css. The speech
     cloud hides with her. Never while the Iris chat is open.
     Measured on MAIN 26 Oct before the change (390x664): Iris covered See It in My Room and the
     wishlist heart (framed print, scroll 100 to 200), the heart beside Add to Cart (apparel 150 to 300),
     the Find my size tile (apparel 800 to 1050) and, on a Danish visit, the swatch arrow at rest.
     The spot is read off a hidden probe (.int-satc-irisprobe) that copies Iris's position rule with NO
     transition, so the decision is made where she is going, not where she is mid-move when the bar
     slides in. Keep that rule in step with the .int-iris-l rule in assets/int-iris-launcher.js. */
  var IRIS_SEL = '.int-gswatch, .int-gsw-arrow, ' + CONTROL_SEL + ', [data-form-holder] button[name="add"], ' +
                 '.custom-swym-heart, #fake-fit-quiz, #fake-fit-quiz-note button, [data-int-mob-quiz], [data-int-fms-open], ' +
                 '[data-int-room-open], [data-int-fas-open]';
  var irisAside = false, irisProbe = null, irisSeen = false;
  function irisSet(on, instant) {
    if (on === irisAside) return;
    irisAside = on;
    var b = document.body;
    if (instant) {
      b.classList.add('int-iris-nt');
      requestAnimationFrame(function() { requestAnimationFrame(function() { b.classList.remove('int-iris-nt'); }); });
    }
    b.classList.toggle('int-iris-aside', on);
  }
  function irisCheck() {
    if (window.innerWidth >= 768) { irisSet(false, true); return; }
    var ir = document.querySelector('.int-iris-l');
    if (!ir) return;
    var first = !irisSeen; irisSeen = true;
    if (document.documentElement.classList.contains('int-iris-on')) { irisSet(false, false); return; }
    if (!irisProbe) {
      irisProbe = document.createElement('div');
      irisProbe.className = 'int-satc-irisprobe';
      irisProbe.setAttribute('aria-hidden', 'true');
      document.body.appendChild(irisProbe);
    }
    var h = irisProbe.getBoundingClientRect(), pad = 4, hit = false;
    var els = document.querySelectorAll(IRIS_SEL);
    for (var i = 0; i < els.length && !hit; i++) {
      var r = els[i].getBoundingClientRect();
      if (!(r.width > 0 && r.height > 0) || r.height > 420) continue;   /* a hidden control, or a page box */
      if (r.left < h.right + pad && r.right > h.left - pad && r.top < h.bottom + pad && r.bottom > h.top - pad) {
        if (getComputedStyle(els[i]).visibility !== 'hidden') hit = true;
      }
    }
    irisSet(hit, first);
  }
  /* Iris is added by her deferred launcher after this file has run: decide in the same task she
     appears, before she is painted, so she never flashes in over a control and then leaves. */
  if (window.MutationObserver && !document.querySelector('.int-iris-l')) {
    try {
      var irisMo = new MutationObserver(function() {
        if (document.querySelector('.int-iris-l')) { irisMo.disconnect(); irisCheck(); }
      });
      irisMo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function() { irisMo.disconnect(); }, 20000);
    } catch (e) {}
  }
  /* A swipe inside the colour row moves the swatches without a page scroll. */
  document.addEventListener('scroll', function(e) {
    if (e.target !== document && e.target !== document.documentElement) onStickyScroll();
  }, { capture: true, passive: true });

  function init() {
    bar = document.getElementById('int-sticky-atc');
    if (!bar) return;
    btn      = bar.querySelector('[data-sticky-btn]');
    btnLabel = bar.querySelector('[data-sticky-btn-label]');
    priceEl  = bar.querySelector('[data-sticky-price]');

    /* One-size products: treat as already picked */
    var fs = findSizeFieldset();
    if (fs) {
      var inputs = fs.querySelectorAll('input[type="radio"]');
      if (inputs.length === 1) {
        var wrap = inputs[0].closest('.radio__button, radio-swatch');
        var txt  = wrap ? wrap.textContent.toLowerCase() : '';
        if (txt.indexOf('one size') !== -1) hasUserPickedSize = true;
      }
    }

    /* Deep-link with ?variant=… means size was implicitly chosen elsewhere */
    if (window.location.search.indexOf('variant=') !== -1) {
      hasUserPickedSize = true;
    }

    /* Snapshot the currently-checked size at page load. onVariantChange
       compares against this to detect when the user picks a new size. */
    initialSizeValue = getCurrentSizeValue();

    /* INT 2026-10-11: framed prints open on a chosen size (60x80), read it off the form. */
    if (sizeIsPopout()) hasUserPickedSize = true;
    syncFromForm();

    btn.addEventListener('click', onClick);
    document.addEventListener('change', onSizeChange, true);
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('theme:variant:change', onVariantChange, true);

    /* INT 2026-10-26: no slide on the FIRST decision. If the real button is below the screen the
       bar is simply there in the first frame; it only slides on later scroll changes. */
    bar.style.transition = 'none';
    bar.hidden = false;
    bar.setAttribute('aria-hidden', 'false');
    bar.setAttribute('data-ready', '1');
    bar.setAttribute('data-visible', '0');
    document.body.classList.add('int-has-sticky-atc');
    render();

    computeStickyThreshold();
    updateStickyVisible();
    irisCheck();
    requestAnimationFrame(function() { requestAnimationFrame(function() { bar.style.transition = ''; }); });
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    /* Late layout (the gallery getting its height, images, fonts, the fit tile) moves the real
       button and the controls without any scroll: check again whenever the page changes size. */
    window.addEventListener('load', onStickyScroll);
    setTimeout(onStickyScroll, 1500);
    if (window.ResizeObserver) {
      try { new ResizeObserver(onStickyScroll).observe(document.body); } catch (e) {}
    }
  }

  /* INT 2026-10-26: start at once when the bar's markup is already parsed (it sits right above
     this tag, and the product form is earlier still). Waiting for DOMContentLoaded held the bar
     back until every deferred theme script had run, about 2.5 s after first paint on a phone. */
  if (document.readyState !== 'loading' || document.getElementById('int-sticky-atc')) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Resize handler — hide on desktop, show on mobile */
  window.addEventListener('resize', function() {
    if (!bar || bar.getAttribute('data-ready') !== '1') return;
    if (window.innerWidth >= 768) {
      stickyVisible = false;
      bar.setAttribute('data-visible', '0');
      document.body.classList.remove('int-has-sticky-atc');
      irisSet(false, true);
    } else {
      computeStickyThreshold();
      document.body.classList.add('int-has-sticky-atc');
      stickyVisible = false;
      updateStickyVisible();
      irisCheck();
    }
  }, { passive: true });
})();
